module.exports = __webpack_public_path__ + "static/img/bg-es.b8dbfc88.png";